module.exports = __webpack_public_path__ + "img/Backshop.3c116c02.svg";